export default "__VITE_ASSET__yzEY9k9U__"